import { render, staticRenderFns } from "./concurrentCollapse.vue?vue&type=template&id=418d13c2"
import script from "./concurrentCollapse.vue?vue&type=script&lang=js"
export * from "./concurrentCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports